import * as React from "react";
import { SVGProps } from "react";

const GoldTierLarge = (
  props: SVGProps<SVGSVGElement> & { bgcolor?: string }
) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 73 77"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity="0.2"
      d="M36.393 11.2729C39.7077 11.4236 42.3072 13.4724 42.1991 15.8489C42.091 18.2255 39.3164 20.0298 36.0017 19.8791C32.6871 19.7284 30.0876 17.6797 30.1957 15.3031C30.3037 12.9266 33.0784 11.1222 36.393 11.2729Z"
      fill="white"
    />
    <path
      d="M61.8068 36.1574L61.8068 40.2747C61.8068 54.3685 50.4842 65.6911 36.3904 65.6911C22.2965 65.6911 10.9739 54.3685 10.9739 40.2747L10.9739 36.1574H61.8068Z"
      fill="#F19520"
    />
    <path
      d="M54.5857 54.5858C44.5367 64.6348 28.2441 64.6348 18.1951 54.5858C8.14613 44.5369 8.14613 28.2443 18.1951 18.1953C28.2441 8.1463 44.5367 8.1463 54.5857 18.1953C64.6346 28.2443 64.6346 44.5369 54.5857 54.5858Z"
      fill="#F8E452"
    />
    <path
      d="M48.4938 48.4951C41.8093 55.1796 30.9715 55.1796 24.2869 48.4951C17.6024 41.8105 17.6024 30.9727 24.2869 24.2881C30.9715 17.6036 41.8093 17.6036 48.4938 24.2881C55.1784 30.9727 55.1784 41.8105 48.4938 48.4951Z"
      fill="#F19520"
    />
    <path
      d="M10.6604 36.3112C10.6604 50.5789 22.1226 62.0411 36.3903 62.0411C47.2914 62.0411 56.5895 55.3081 60.3568 45.7696C52.1008 47.1322 41.5202 45.5291 31.1802 40.4793C23.4051 36.712 17.153 31.7424 12.7445 26.372C11.3818 29.498 10.6604 32.7844 10.6604 36.3112Z"
      fill="#EFD745"
    />
    <path
      d="M48.4938 48.4951C41.8093 55.1796 30.9715 55.1796 24.2869 48.4951C17.6024 41.8105 17.6024 30.9727 24.2869 24.2881C30.9715 17.6036 41.8093 17.6036 48.4938 24.2881C55.1784 30.9727 55.1784 41.8105 48.4938 48.4951Z"
      fill="#F19520"
    />
    <path
      d="M22.2839 26.6119C25.0092 24.6882 28.3757 23.566 31.9827 23.6462C41.4411 23.6462 49.0558 31.2609 49.0558 40.7193C49.0558 44.2461 47.9336 47.6126 46.0901 50.4181C50.5788 47.3722 53.5445 42.1621 53.4644 36.3107C53.4644 26.8524 45.8496 19.2376 36.3913 19.2376C30.6201 19.2376 25.41 22.2034 22.2839 26.6119Z"
      fill="#D06D28"
    />
    <path
      d="M26.7717 41.2L25.0082 32.7035C24.8479 31.902 25.7296 31.3409 26.451 31.7416C27.8938 32.7035 29.9779 34.3066 31.6611 36.4708C31.9818 36.9517 32.7032 36.7113 32.8635 36.2304C33.4246 33.4249 34.8674 30.8599 35.7491 29.6576C36.1498 29.0965 36.9514 29.0965 37.1919 29.6576C38.0736 31.0202 39.5164 33.4249 40.0775 36.2304C40.1576 36.7914 40.9592 36.9518 41.2798 36.4708C42.963 34.3066 45.0471 32.7035 46.4899 31.7416C47.1311 31.2607 48.093 31.902 47.9327 32.7035C47.4518 35.1082 46.57 39.0358 46.1693 41.2C45.9288 42.0817 45.1272 42.7229 44.3257 42.7229L28.9359 42.7229C27.7335 42.6428 26.932 42.0015 26.7717 41.2Z"
      fill="#F8E452"
    />
    <path
      opacity="0.2"
      d="M36.4123 62.0294C33.0943 62.0293 30.4045 60.1007 30.4045 57.7217C30.4046 55.3427 33.0944 53.4142 36.4125 53.4143C39.7306 53.4143 42.4204 55.3429 42.4203 57.7219C42.4203 60.1009 39.7304 62.0294 36.4123 62.0294Z"
      fill="white"
    />
    <path
      opacity="0.2"
      d="M39.0105 15.9215C40.574 15.9926 41.8 16.9628 41.7488 18.0886C41.6976 19.2143 40.3887 20.0693 38.8251 19.9982C37.2616 19.9271 36.0356 18.9569 36.0868 17.8311C36.138 16.7054 37.447 15.8504 39.0105 15.9215Z"
      fill="white"
    />
  </svg>
);
export default GoldTierLarge;
